import React from 'react';
import { FormControl, FormLabel, Switch } from '@chakra-ui/react';

const DeviceTargeting = ({ formik }) => {
  return (
    <>
      <FormControl>
        <FormLabel>Show on Mobile</FormLabel>
        <Switch
          name="actionProps.device.screen.mobile.show"
          isChecked={formik.values.actionProps.device.screen.mobile.show}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Show on Tablet</FormLabel>
        <Switch
          name="actionProps.device.screen.tablet.show"
          isChecked={formik.values.actionProps.device.screen.tablet.show}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Show on Desktop</FormLabel>
        <Switch
          name="actionProps.device.screen.desktop.show"
          isChecked={formik.values.actionProps.device.screen.desktop.show}
          onChange={formik.handleChange}
        />
      </FormControl>
    </>
  );
};

export default DeviceTargeting;